import React, {PureComponent} from 'react';
import {withTranslation} from "react-i18next";
import {Modal} from 'react-responsive-modal';

class PortraitModal extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.checkPortraitMode = this.checkPortraitMode.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.checkPortraitMode();
        // Detect whether device supports orientationchange event, otherwise fall back to
        // the resize event.
        let supportsOrientationChange = "onorientationchange" in window;
        let orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";
        window.addEventListener(orientationEvent, () => {
            this.closeModal();
            this.checkPortraitMode();
        }, false);
    }

    checkPortraitMode() {
        let width = window.screen.width;
        let height = window.screen.height;
        if (height > width) {
            setTimeout(() => {
                this.openModal();
            }, 1000);
        }
    }

    openModal() {
        this.setState({
            modalOpen: true
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false
        });
    }

    render() {
        return (
            <Modal open={this.state.modalOpen}
                   onClose={() => {
                   }}
                   animationDuration={200}
                   center={true}
                   classNames={{modal: "small-modal fadeInLeft"}}
                   showCloseIcon={false}
            >
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <h3 className={"text-center"}><b className={"App_header"} style={{color: "#000000"}}>{this.props.t("portraitDetected")}!</b></h3>
                    </div>
                    <div className={"col-sm-12 text-center"} style={{paddingLeft: 35, paddingRight: 35}}>
                        <h3 className={"App_black_text"} style={{color: "#000000"}}>{this.props.t("portraitWarning")}.</h3>
                        <img src={"https://insomniainc.com/wp-content/uploads/2017/02/rotatedevice.gif"} height={80} alt={"rotateDevice"}/>
                    </div>
                    <div className={"col-sm-12 text-center"}>
                        <button
                            className={"btn button"}
                            style={{background: "#ff0003", color: "#FFFFFF", marginBottom: 20}}
                            onClick={this.closeModal}
                        >
                            {this.props.t("ok")}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default withTranslation("translations")(PortraitModal);